export default __webpack_public_path__ + "static/media/close.d3d2087b.svg";